import { useQuery } from "@tanstack/react-query";
import { queryService } from "@/api/services/query-service";
import {
  TokenUsageRunHistoryParams,
  TokenUsageRunHistoryResponse,
  TokenUsageRunHistoryModel,
} from "@/api/models/api-types";

const fetchRunHistory = async (
  params: TokenUsageRunHistoryParams
): Promise<TokenUsageRunHistoryResponse["data"]> => {
  const response = await queryService.getUserTokenUsageHistory(params);
  return response.data;
};

export const useRunHistoryQuery = (
  params: TokenUsageRunHistoryParams = {}
) => {
  return useQuery({
    queryKey: ["token-usage-run-history", params],
    queryFn: () => fetchRunHistory(params),
    refetchOnMount: "always",
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    staleTime: 0,
    gcTime: 5 * 60 * 1000,
  });
};

export const useRunHistory = (params: TokenUsageRunHistoryParams = {}) => {
  const {
    data,
    isLoading: isRunHistoryLoading,
    error: runHistoryError,
    refetch: refetchRunHistory,
  } = useRunHistoryQuery(params);

  const runHistory: TokenUsageRunHistoryModel[] = data?.result ?? [];
  const meta = data?.meta;
  const totalPages = meta?.totalPage ?? 1;
  const currentPage = meta?.page ?? params.page ?? 1;
  const totalRecords = meta?.total ?? 0;
  const limit = meta?.limit ?? params.limit ?? runHistory.length;

  return {
    runHistory,
    meta,
    totalPages,
    currentPage,
    totalRecords,
    limit,
    isRunHistoryLoading,
    runHistoryError,
    refetchRunHistory,
  };
};

